import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import 'bootstrap/dist/css/bootstrap.min.css';

import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Switch from '@mui/material/Switch';

import MuiDialogAlert from '../components/MuiDialogAlert';


import LoadingOverlay from 'react-loading-overlay';
const axios = require('axios').default;


function SmsContacts() {

  const [loadingActive, setLoadingActive] = useState(false);
  const [smsContactName, setSMSContactName] = useState([]);
  const [smsContactPhone, setSMSContactPhone] = useState([]);
  const [smsEnable, setSMSEnable] = useState([]);

  const [modalHeader, setModalHeader] = useState("");
  const [modalBody, setModalBody] = useState("Update Successful");
  const [showModal, setShowModal] = useState(false);
  
  const handleClose = () => setShowModal(false);
  let navigate = useNavigate();
  
  // Load current settings from DB
  useEffect(() => {
    let url = process.env.REACT_APP_API_SERVER + "/load_settings";
    setLoadingActive(true);

    axios.post(url, {
      "settings": "sms",
      "api_user": JSON.parse(localStorage.getItem('user'))
    })
      .then(function (response) {
        
        if (response.data.status === "API_AUTH_ERROR") {
          // Force user to re-login if unable to autheticate with the API
          navigate("/logout")
        }
        
        setSMSContactName(
          [
            response.data[0].name,
            response.data[1].name,
            response.data[2].name
          ]
        )

        setSMSContactPhone(
          [
            response.data[0].phone,
            response.data[1].phone,
            response.data[2].phone
          ]
        )

        setSMSEnable(
          [
            response.data[0].enable === 1 ? true : false,
            response.data[1].enable === 1 ? true : false,
            response.data[2].enable === 1 ? true : false
          ]
        )

        setLoadingActive(false)
      })
      .catch(function (error) {
        setModalHeader("Error Loading SMS Contacts")
        setModalBody(error)
        setShowModal(true)

      });
  }, [])

  function updateForm(e) {


    let id = e.target.id;
    let val = e.target.value;


    if (e.target.id.includes("smsEnable")) {
      val = e.target.checked;
    }

    for (let i = 0; i < 3; i++) {
      if (id === "smsContactName_" + i) {
        setSMSContactName(existingItems => {
          return [
            ...existingItems.slice(0, i),
            val,
            ...existingItems.slice(i + 1),
          ]
        })
      }
      if (id === "smsContactPhone_" + i) {
        const re = /^[0-9\b]+$/;
        const max_length = 8

        if ((val === '' || re.test(val)) && val.length<= max_length) { // Check that the input is numbers and the length is not longer that max_length
          setSMSContactPhone(existingItems => {
            return [
              ...existingItems.slice(0, i),
              val,
              ...existingItems.slice(i + 1),
            ]
          })
        }

      }
      if (id === "smsEnable_" + i) {
        setSMSEnable(existingItems => {
          return [
            ...existingItems.slice(0, i),
            val,
            ...existingItems.slice(i + 1),
          ]
        })
      }
    }

  }

  function save_btn_click() {
    let url = process.env.REACT_APP_API_SERVER + "/save_settings";
    setLoadingActive(true);

    axios.post(url, {
      "settings": "sms",
      "api_user": JSON.parse(localStorage.getItem('user')),
      smsContactName_0: smsContactName[0],
      smsContactName_1: smsContactName[1],
      smsContactName_2: smsContactName[2],
      smsContactPhone_0: smsContactPhone[0],
      smsContactPhone_1: smsContactPhone[1],
      smsContactPhone_2: smsContactPhone[2],
      smsEnable_0: smsEnable[0],
      smsEnable_1: smsEnable[1],
      smsEnable_2: smsEnable[2]
    })
      .then(function (response) {

        if (response.data.status === "API_AUTH_ERROR") {
          // Force user to re-login if unable to autheticate with the API
          navigate("/logout")
        }

        let data = response.data
        if (data.status === "OK"){
          setModalHeader("Success")
          setModalBody("Updated SMS Contacts")
          setShowModal(true);
        }
        setLoadingActive(false);
      })
      .catch(function (error) {
        setModalHeader("Error: Unable to update SMS Contacts")
        setModalBody(error)
        setShowModal(true)

      });
  }

  return (
    <div align="left" style={{ height: "100%" }}>
      <LoadingOverlay
        active={loadingActive}
        spinner
        text="Loading"
        className="spinner_div"
      >
        <div className="form_area">

          <div className="page_header">KEY PERSONNEL</div>

            <table>
                <tr>
                  <td valign="center" className="form-labels valign-center" width="70px">Name</td>
                  <td align='left' className='valign-center' width="230px">

                    <TextField 
                      id="smsContactName_0" 
                      onChange={updateForm}
                      variant="outlined" 
                      value={smsContactName[0]}
                      sx={{
                        '& legend': { display: 'none' },
                        '& fieldset': { top: 0 },
                      }}
                    />

                  </td>
                  <td valign="center" className="form-labels valign-center" width="70px">Phone</td>
                  <td valign="center" className="form-labels valign-center" style={{fontWeight:"900"}} width="35px">+65</td>
                  <td align='left' className='valign-center' width="230px">
                  
                    <TextField
                      id="smsContactPhone_0"
                      onChange={updateForm}
                      variant="outlined"
                      value={smsContactPhone[0]}
                      sx={{
                        '& legend': { display: 'none' },
                        '& fieldset': { top: 0 },
                      }}
                    />

                  </td>
                  <td className='valign-center' width="70px">
                    <label className="form-labels form-check-label" htmlFor="smsEnable_0">Enable</label>
                  </td>
                  <td align='left' colSpan="2" className='valign-center'>
                    <div className="form-check form-switch form-switch-md" style={{ paddingLeft: "10px",marginTop: "15px" }}>

                      <Switch
                        id="smsEnable_0"
                        onChange={updateForm}
                        checked={smsEnable[0]}
                        value={smsEnable[0] ?? " "}                      
                      />

                    </div>
                  </td>
                </tr>

                <tr><td colSpan={6} style={{height: "10px"}}></td></tr>

                <tr>
                  <td valign="center" className="form-labels valign-center" width="70px">Name</td>
                  <td align='left' className='valign-center' >
                    <TextField
                      id="smsContactName_1"
                      onChange={updateForm}
                      variant="outlined"
                      value={smsContactName[1]}
                      sx={{
                        '& legend': { display: 'none' },
                        '& fieldset': { top: 0 },
                      }}
                    />
                  </td>
                  <td valign="center" className="form-labels valign-center" width="70px">Phone</td>
                  <td valign="center" className="form-labels valign-center" style={{fontWeight:"900"}} width="35px">+65</td>
                  <td align='left' className='valign-center' >
                    <TextField
                      id="smsContactPhone_1"
                      onChange={updateForm}
                      variant="outlined"
                      value={smsContactPhone[1]}
                      sx={{
                        '& legend': { display: 'none' },
                        '& fieldset': { top: 0 },
                      }}
                    />
                  </td>
                  <td className='valign-center' width="70px">
                    <label className="form-labels form-check-label" htmlFor="smsEnable_2">Enable</label>
                  </td>
                  <td align='left' colSpan="2" className='valign-center'>
                  <div className="form-check form-switch form-switch-md" style={{ paddingLeft: "10px", marginTop: "15px" }}>
                      <Switch
                        id="smsEnable_1"
                        onChange={updateForm}
                        checked={smsEnable[1]}
                        value={smsEnable[1]}                      
                      />
                    </div>
                  </td>
                </tr>

                <tr><td colSpan={6} style={{ height: "10px" }}></td></tr>

                <tr>
                  <td valign="center" className="form-labels valign-center" width="70px">Name</td>
                  <td align='left' className='valign-center'>
                    <TextField
                      id="smsContactName_2"
                      onChange={updateForm}
                      variant="outlined"
                      value={smsContactName[2]}
                      sx={{
                        '& legend': { display: 'none' },
                        '& fieldset': { top: 0 },
                      }}
                    />
                  </td>
                  <td valign="center" className="form-labels valign-center" width="70px">Phone</td>
                  <td valign="center" className="form-labels valign-center" style={{fontWeight:"900"}} width="35px">+65</td>
                  <td align='left' className='valign-center'>
                    <TextField
                      id="smsContactPhone_2"
                      onChange={updateForm}
                      variant="outlined"
                      value={smsContactPhone[2]}
                      sx={{
                        '& legend': { display: 'none' },
                        '& fieldset': { top: 0 },
                      }}
                    />
                  </td>
                  <td className='valign-center' width="70px">
                    <label className="form-labels form-check-label" htmlFor="smsEnable_3">Enable</label>
                  </td>
                  <td align='left' colSpan="2" className='valign-center'>
                  <div className="form-check form-switch form-switch-md" style={{ paddingLeft: "10px", marginTop: "15px" }}>
                      <Switch
                        id="smsEnable_2"
                        onChange={updateForm}
                        checked={smsEnable[2]}
                        value={smsEnable[2]}                      
                      />
                    </div>
                  </td>
                </tr>

            </table>

            <div style={{height: "30px"}}></div>

            <div align="left">
              <Button
                variant="contained"
                color="success"
                onClick={save_btn_click}
                sx={{ width: 200, height: 50 }}
              >
                Update Settings
              </Button>
            </div>

            <div style={{ height: "30px" }}></div>

          <MuiDialogAlert
            showModal={showModal}
            handleClose={handleClose}
            bodyContent={modalBody}
            title={modalHeader}
            bodyClass="whitespace"
          />

        </div>

      </LoadingOverlay>
    </div>
  )
}

export default SmsContacts